import z from "zod";

export const studentNoChargeField = z.boolean().optional();

export const studentTuitionField = z
  .union([z.string(), z.number()])
  .optional()
  .transform((val) => {
    if (val === "" || val === null || val === undefined) return undefined;
    const num = typeof val === "string" ? parseFloat(val) : val;
    return isNaN(num) ? undefined : num;
  })
  .pipe(z.number().min(0).optional());
